import { Component, signal } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Asset, AssetType } from 'app/classes/asset';
import { Issue } from 'app/classes/issue';
import { Org } from 'app/classes/org';
import { Site } from 'app/classes/site';
import { RAGType } from 'app/interfaces/annotation-and-rags';
import { APIService } from 'app/shared/api.service';
import { AssetService } from 'app/shared/asset.service';
import { IssueTrackingStatusType, IssueTrackingProgressType, IssueTrackingService } from 'app/shared/issue-tracking.service';
import { SiteService } from 'app/shared/site.service';
import { StoreService } from 'app/shared/store.service';
import moment from 'moment-timezone';

@Component({
  selector: 'app-issue-tracking-create-site',
  standalone: false,
  templateUrl: './issue-tracking-create-site.component.html',
  styleUrl: './issue-tracking-create-site.component.css'
})
export class IssueTrackingCreateSiteComponent {
  site = signal<Site>(null);
  asset = signal<Asset>(null);
  sites = signal<Site[]>(null);
  title: string;
  details: string;

  rag: RAGType = 'amber';
  progress: IssueTrackingProgressType = 'Not Started';
  dialog = signal<'entities'>(null);
  entities = signal<any[]>([]);
  issueType: 'issue' | 'task' = 'issue';
  org: Org;
  orgChanged = false;
  isSelectingAsset = signal<boolean>(false);
  assets = signal<Asset[]>(null);
  assetTypes: AssetType[];
  useRange: boolean = true;
  chartRange: any;
  substatus_id = 1;
  statusOptions: { id: number, title: string }[];
  isLoadingAssets = signal<boolean>(false);
  isSavingIssue = signal<boolean>(false);

  constructor(private siteService: SiteService, private assetService: AssetService, private issueTracking: IssueTrackingService, private router: Router, private route: ActivatedRoute, private storeService: StoreService, private apiService: APIService) {
    this.siteService.getSites().then(sites => {
      this.sites.set(sites);
    });
    this.statusOptions = issueTracking.getOptionsForStatus();
  }

  chartChange(ev: any) {
    console.log(`chart change`, ev);
    const fromUK = moment(ev.from).tz('Europe/London').format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    const toUK = moment(ev.to).tz('Europe/London').format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    this.chartRange = { from: fromUK, to: toUK };
  }

  selectAssetClick() {
    this.isSelectingAsset.set(true);
    this.assetTypes = this.assetService.getAssetTypes();
    this.isLoadingAssets.set(true);
    this.assetService.getAssetsForSite(this.site()?.id).then(assets => {

      assets.forEach(asset => {
        const type = this.assetTypes.find(type => type.id === asset.assetType_id);
        asset.assetTypeTitle = `${type?.title ?? asset.assetType_id}`;
      });
      this.isLoadingAssets.set(false);
      this.assets.set(assets);
    });
  }

  clearSiteClick() {
    this.site.set(null);
    this.asset.set(null);
    this.assets.set(null);
    this.isSelectingAsset.set(false);
  }

  assetClick(asset: Asset) {
    this.isSelectingAsset.set(false);
    this.apiService.getAsset(asset.id).then(a => {
      this.asset.set(a);
      this.assets.set(null);
      this.entities.set([{ type: 'site', obj: this.site() }, { type: 'asset', obj: a }]);
    });
  }

  siteClick(site: Site) {
    this.isSelectingAsset.set(false);
    this.site.set(site);
    this.asset.set(null);
    this.entities.set([{ type: 'site', obj: site }]);
  }

  save() {
    if (!this.title?.length || !this.details?.length) {
      this.apiService.toastWarn('Please enter a summary and details.', null);
      return;
    }

    this.isSavingIssue.set(true);
    const range = this.useRange ? this.chartRange : null;
    const issue = new Issue({ title: this.title, description: this.details, rag: this.rag, taskProgress: this.progress, issueType: this.issueType, range, substatus_id: this.substatus_id });

    issue.entities = this.entities().map(entity => ({ field: entity.type + '_id', value: entity.obj.id }));

    this.apiService.toastSuccess('creating issue.', null, 1000);
    this.issueTracking.createIssue(issue).then(response => {
      this.isSavingIssue.set(false);
      this.apiService.toastSuccess('Issue created.', null, 1000);
      console.log(response);
      this.router.navigate(['/issuetracking']);
    });
  }

  entitiesSelected(response) {
    console.log('RESPONSE', response);
    this.entities.update(entities => {
      if (!entities) {
        entities = [];
      }
      entities.push(response);
      return entities;
    });
    this.dialog.set(null);
  }

  removeEntity(entity) {
    this.entities.update(entities => {

      return entities.filter(e => e.type !== entity.type || (e.type === entity.type && e.obj.id !== entity.obj.id));
    });
  }

  useThisOrg(org: any) {
    console.log(org);
    this.orgChanged = (this.org.id !== org.id);
    this.org = org;
    this.entities.update(entities => {
      return entities.filter(e => e.type !== 'org');
    })
  }
}
